import { parseAsString, parseAsStringLiteral } from 'nuqs';
import { AccountDrilldownTabSchema } from '../../src/shared/flow/account-drilldown-tabs';

/**
 * The shared Flow URL vocabulary (`docs/flow/unified-shell-and-deeplinking.md` section 4, plus `signal`
 * from its link registry): one name and one parser per concept, for every mini-app and the web app.
 * Read them with nuqs directly, e.g.
 * `useQueryState('play', flowUrlParams.play.withOptions({ history: 'replace' }))`; add a default or
 * options at the call site. A param only one app reads stays in that app's own `*-url-state.ts`.
 *
 * `tab` is each app's own subtab, so its values differ per app: an app that knows its tabs narrows it
 * with `parseAsStringLiteral(values)` under the same key.
 */
export const flowUrlParams = {
  /** Campaign id. */
  campaign: parseAsString,
  /** Contact id; expands the person in the roster and never picks a tab. */
  contact: parseAsString,
  /** Signal Action / task id. Frozen: old Slack links carry it. */
  action: parseAsString,
  /** Play id. */
  play: parseAsString,
  /** Signal id: the Signals-tab row opened from a link (`signalInCommandCenter`). */
  signal: parseAsString,
  /** The tab an account drilldown opens on. */
  accountTab: parseAsStringLiteral(AccountDrilldownTabSchema.options),
  /** App-internal subtab. */
  tab: parseAsString,
  /** Command Center omnibox seed query. */
  q: parseAsString,
  /**
   * Signals "All else": `1` opens My Signals minus the rows the viewer's favorites include. Honored only on
   * My Signals (cleared on any other view), never saved with a view. A copied link carries it, so the
   * recipient sees My Signals minus THEIR favorites.
   */
  exclude_favs: parseAsStringLiteral(['1'] as const),
};
